export function managedAddEventListener(element, event, listener, options) {
  // rest of the function is not taking effect for now. this if-else
  // is for us to use when we develop locally and using Cypress to surface problems
  // see `TODO: managedAddEventListener`
  if (!window.Cypress) {
    return element.addEventListener(event, listener, options);
  }

  if (!element.__trackListener) {
    element.__trackListener = {};
  }

  if (!element.__trackListener[event]) {
    element.__trackListener[event] = {};
  }

  // actually we should track `listener` itself, since that is how
  // removeEventListener works; if javascript function is declared
  // multiple times (e.g. htmx swap), they are actually different
  // functions; removeEventListener will not remove the listener
  // now we treat it as the same if the "code" is the same
  const listenerString = listener.toString();
  const previousListener = element.__trackListener[event][listenerString];

  if (previousListener) {
    // error if previous listener exists
    console.error(
      "managedAddEventListener: previous listener exists!",
      element,
      event,
      listenerString
    );
    throw new Error("managedAddEventListener: previous listener exists!");
  }

  // Attach the new listener and track it
  element.addEventListener(event, listener, options);
  element.__trackListener[event][listenerString] = listener;
}
window.managedAddEventListener = managedAddEventListener; // countdown-spinner.js

export function managedRemoveEventListener(element, event, listener, options) {
  // rest of the function is not taking effect for now. this if-else
  // is for us to use when we develop locally and using Cypress to surface problems
  // see `TODO: managedAddEventListener`
  if (!window.Cypress) {
    return element.removeEventListener(event, listener, options);
  }

  if (element.__trackListener && element.__trackListener[event]) {
    // actually we should track `listener` itself, since that is how
    // removeEventListener works; if javascript function is declared
    // multiple times (e.g. htmx swap), they are actually different
    // functions; removeEventListener will not remove the listener
    // now we treat it as the same if the "code" is the same
    const listenerString = listener.toString();
    const trackedListener = element.__trackListener[event][listenerString];

    if (trackedListener) {
      element.removeEventListener(event, trackedListener);
      delete element.__trackListener[event][listenerString];
    }
  }
}
window.managedRemoveEventListener = managedRemoveEventListener; // countdown-spinner.js
